<kt-portlet class="knostos-grid">
  <kt-portlet-header
    [title]="'TABLE.USER_LIST' | translate"
    [class]="'card-head-lg'"
    [viewLoading$]="dataSource.loading$"
  >
    <ng-container ktPortletTools>
      <div>
        <button mat-raised-button class="btn btn-light-primary" (click)="syncUsersToTwixor()">
          Sync to Knostos Connect
        </button>
        <ng-template ngxPermissionsOnly="canAddUser">
          <button mat-raised-button (click)="addUser()" class="btn btn-primary ml-2">
            <span
              inlineSVG="assets/media/svg/icons/General/add_circle_icon.svg"
              class="svg-icon svg-icon-md"
            ></span>
            <span>Add User</span>
          </button>
        </ng-template>
        <button
          mat-raised-button
          matTooltip="Export as CSV"
          class="btn btn-icon btn-primary ml-2"
          (click)="exportUsersAsCSV($event)"
        >
          <i class="fas fa-download"></i>
        </button>
      </div>
    </ng-container>
  </kt-portlet-header>
  <kt-portlet-body>
    <div class="mb-5">
      <div class="d-flex align-items-end justify-content-end">
        <mat-form-field appearance="standard">
          <mat-label>{{ 'TABLE.SEARCH' | translate }}</mat-label>
          <input matInput #searchInput [placeholder]="'TABLE.SEARCH' | translate" />
          <button
            *ngIf="searchInput.value"
            matSuffix
            mat-icon-button
            (click)="resetSearchInput($event, searchInput, true)"
          >
            <mat-icon>close</mat-icon>
          </button>
          <mat-hint align="start">
            <strong>{{ 'TABLE.SEARCH' | translate }}</strong>
            {{ 'TABLE.IN_ALL_FIELDS' | translate }}
          </mat-hint>
        </mat-form-field>
        <button
          matTooltip="Search by Field/s"
          style="margin-bottom: 1.34375em"
          class="btn btn-sm btn-icon btn-light ml-2"
          (click)="toggleSearchBar($event)"
        >
          <span
            inlineSVG="assets/media/svg/icons/General/columns.svg"
            class="svg-icon svg-icon-md"
          ></span>
        </button>
      </div>
      <div class="collapse" [ngClass]="{ show: selection.selected.length > 0 }">
        <label>
          <span class="font-weight-bold">{{ 'GLOBAL.SELECTED_RECORDS_COUNT' | translate }}</span>
          {{ selection.selected.length }}
        </label>
        <div>
          <button mat-raised-button class="btn btn-danger" (click)="deleteUsers()">
            <mat-icon>delete</mat-icon>
            {{ 'TABLE.DELETE' | translate }}
          </button>
          <button mat-raised-button class="btn btn-light ml-2" (click)="updateStatusForUsers()">
            <mat-icon>update</mat-icon>
            {{ 'TABLE.UPDATE' | translate }} {{ 'TABLE.STATUS' | translate }}
          </button>
        </div>
      </div>
    </div>
    <div class="mat-table-wrapper">
      <mat-table #sort="matSort" matSort [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="select">
          <mat-header-cell *matHeaderCellDef class="mat-column-checkbox">
            <mat-checkbox
              [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()"
              (change)="$event ? masterToggle() : null"
            ></mat-checkbox>
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="mat-column-checkbox">
            <mat-checkbox
              [checked]="selection.isSelected(row)"
              (click)="$event.stopPropagation()"
              (change)="$event ? selection.toggle(row) : null"
            ></mat-checkbox>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchSelect">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="profile">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let user" class="profile-pic justify-content-center">
            <kt-user-photo
              [create]="'false'"
              [size]="30"
              [type]="'object'"
              [editable]="false"
              [user$]="user"
            ></kt-user-photo>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchProfile">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="fullName">
          <mat-header-cell *matHeaderCellDef mat-sort-header>User</mat-header-cell>
          <mat-cell *matCellDef="let user" class="flex-column align-items-start">
            <span>{{ user.fullName }}</span>
            <a href="mailto:{{ user.email }}">{{ user.email }}</a>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchNameEmail">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>Name/Email</mat-label>
              <input matInput [(ngModel)]="searchNameEmailInput" [placeholder]="'Name/Email'" />
              <button
                *ngIf="searchNameEmailInput"
                matSuffix
                mat-icon-button
                (click)="searchNameEmailInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'USER.USERNAME' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let user">{{ user.userName }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchUsername">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'USER.USERNAME' | translate }}</mat-label>
              <input
                matInput
                [(ngModel)]="searchUsernameInput"
                [placeholder]="'USER.USERNAME' | translate"
              />
              <button
                *ngIf="searchUsernameInput"
                matSuffix
                mat-icon-button
                (click)="searchUsernameInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container *ngIf="currentUserRoleType == 'Super Admin'" matColumnDef="company">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'USER.COMPANY' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let user">{{ user.company }}</mat-cell>
        </ng-container>
        <ng-container *ngIf="currentUserRoleType != 'Super Admin'" matColumnDef="company">
          <mat-header-cell *matHeaderCellDef>{{ 'USER.COMPANY' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let user">{{ currentCompany }}</mat-cell>
        </ng-container>
        <!-- Office (display) -->
        <ng-container matColumnDef="officeName">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Office</mat-header-cell>
          <mat-cell *matCellDef="let user">
            {{ (user?.office?.name || '').trim() ? user.office.name : 'Not set' }}
          </mat-cell>
        </ng-container>

        <!-- Office (search row) -->
        <ng-container matColumnDef="searchOfficeName">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>Office</mat-label>
              <input matInput [(ngModel)]="searchOfficeNameInput" placeholder="Office" />
              <button
                *ngIf="searchOfficeNameInput"
                matSuffix
                mat-icon-button
                (click)="searchOfficeNameInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>

        <ng-container matColumnDef="searchCompany">
          <mat-header-cell *matHeaderCellDef>
            <ng-container *ngIf="currentUserRoleType !== 'Super Admin'">
              <mat-form-field appearance="standard">
                <input matInput disabled [value]="currentCompany" />
              </mat-form-field>
            </ng-container>

            <kt-general-autocomplete
              #searchCompanyAutocomplete
              *ngIf="currentUserRoleType === 'Super Admin'"
              [label]="'USER.COMPANY' | translate"
              [appearance]="'standard'"
              [dataPath]="'data'"
              [loadItemsFunction]="getCompanyAutocomplete"
              [optionFormatter]="formatCompanyOption"
              [valueFormatter]="formatCompanyOption"
              [control]="searchCompanyAutocomplete"
              [required]="false"
              [readOnly]="false"
            ></kt-general-autocomplete>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="engageAgent">
          <mat-header-cell *matHeaderCellDef>Engage Agent</mat-header-cell>
          <mat-cell *matCellDef="let user">
            <span *ngIf="user.agent === true">
              <img
                alt="Has an Engage Agent"
                style="width: calc(35px + 0.390625vw)"
                src="assets/media/svg/icons/Communication/engage.svg"
              />
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchEngageAgent">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'Engage Agent' }}</mat-label>
              <mat-select [(value)]="searchEngageAgentSelect" [placeholder]="'Engage Agent'">
                <mat-option value="">All</mat-option>
                <mat-option value="true">Yes</mat-option>
                <mat-option value="false">No</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="isActive">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'USER.STATUS' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let user">
            <span
              style="width: 61px"
              class="label label-lg label-light-{{
                getItemCssClassByStatus(user.isActive)
              }} label-inline text-center"
            >
              {{ getItemStatusString(user.isActive) }}
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchIsActive">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'TABLE.STATUS' | translate }}</mat-label>
              <mat-select
                [(value)]="searchIsActiveSelect"
                [placeholder]="'TABLE.STATUS' | translate"
              >
                <mat-option value="">All</mat-option>
                <mat-option value="true">Active</mat-option>
                <mat-option value="false">Inactive</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>{{ 'TABLE.ACTIONS' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let user">
            <ng-template ngxPermissionsOnly="canViewUser">
              <button
                matTooltip="{{ 'TABLE.VIEW' | translate }} User"
                class="btn btn-icon btn-light btn-hover-success btn-sm m-1"
                (click)="viewUser(user)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/visible.svg"
                  class="svg-icon svg-icon-md svg-icon-success"
                ></span>
              </button>
            </ng-template>
            <ng-template ngxPermissionsOnly="canEditUser">
              <button
                matTooltip="{{ 'TABLE.UPDATE' | translate }} User"
                class="btn btn-icon btn-light btn-hover-primary btn-sm m-1"
                (click)="editUser(user.id)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/edit_icon.svg"
                  class="svg-icon svg-icon-md svg-icon-primary"
                ></span>
              </button>
            </ng-template>
            <ng-template ngxPermissionsOnly="canActivateUser">
              <button
                matTooltip="Activate/Deactivate User"
                class="btn btn-icon btn-light btn-hover-warning btn-sm m-1"
                (click)="updateSingleStatus(user)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/update_icon2.svg"
                  class="svg-icon svg-icon-md svg-icon-warning"
                ></span>
              </button>
            </ng-template>
            <ng-template ngxPermissionsOnly="canSoftDeleteUser">
              <button
                matTooltip="{{ 'TABLE.DELETE' | translate }} User"
                class="btn btn-icon btn-light btn-hover-danger btn-sm m-1"
                (click)="deleteUser(user)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/delete_icon.svg"
                  class="svg-icon svg-icon-md svg-icon-danger"
                ></span>
              </button>
            </ng-template>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchActions">
          <mat-header-cell *matHeaderCellDef>
            <button
              class="btn btn-sm btn-light-primary w-50 m-1"
              (click)="handleSearchByField($event)"
            >
              {{ 'TABLE.SEARCH' | translate }}
            </button>
            <button class="btn btn-sm btn-light w-50 m-1" (click)="resetSearchBar($event)">
              {{ 'GLOBAL.RESET' | translate }}
            </button>
          </mat-header-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns" class="sticky-header"></mat-header-row>
        <mat-header-row
          [hidden]="!showSearchBar"
          *matHeaderRowDef="searchBarColumns"
          class="search-cols sticky-header"
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
      <div class="mat-table-message" *ngIf="!dataSource.hasItems">
        {{ 'GLOBAL.NO_RECORDS_FOUND' | translate }}
      </div>
      <div class="mat-table-message" *ngIf="dataSource.isPreloadTextViewed$ | async">
        {{ 'GLOBAL.PLEASE_WAIT' | translate }}
      </div>
    </div>
  </kt-portlet-body>
  <kt-portlet-footer>
    <div class="mat-table__bottom">
      <mat-paginator
        [pageSize]="pageSize || 25"
        [pageSizeOptions]="[10, 25, 50, 200]"
        [length]="dataSource.paginatorTotal$ | async"
        [showFirstLastButtons]="true"
      ></mat-paginator>
    </div>
  </kt-portlet-footer>
</kt-portlet>
